<template>
    <div class="mod-gold">
        <van-row class="mod-data-head">
            <van-col span="16">
                <div class="tabs-nav">
                    <a href="javascript:;" class="tabs-nav__item" :class="flag===GOLD_TYPE_TOTAL?'active':''" @click="achieveMoney(GOLD_TYPE_TOTAL)">总榜</a>
                    <a href="javascript:;" class="tabs-nav__item" :class="flag===GOLD_TYPE_MONTH?'active':''" @click="achieveMoney(GOLD_TYPE_MONTH)">本月榜</a>
                    <a href="javascript:;" class="tabs-nav__item" :class="flag===GOLD_TYPE_WEEK?'active':''" @click="achieveMoney(GOLD_TYPE_WEEK)">本周榜</a>
                </div>
            </van-col>
            <van-col span="8" class="ta-right">
                <span>共</span><span class="cl-red">{{listMapNum[flag]?listMapNum[flag]:0}}</span><span>人参与</span>
            </van-col>
        </van-row>
        <div v-show="moneyIndex == GOLD_TYPE_TOTAL" class="achieveCon" id="js-achieveCon-Zero">
            <rank-list v-if="listMap1" :list="listMap1" thead="累计赚取(金币)"></rank-list>
        </div>
        <div v-show="moneyIndex == GOLD_TYPE_MONTH" class="achieveCon" id="js-achieveCon-One">
            <rank-list v-if="listMap2" :list="listMap2" thead="累计赚取(金币)"></rank-list>
        </div>
        <div v-show="moneyIndex == GOLD_TYPE_WEEK" class="achieveCon" id="js-achieveCon-Two">
            <rank-list v-if="listMap3" :list="listMap3" thead="累计赚取(金币)"></rank-list>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'
    import RankList from '../mod/rank-list'
    export default {
        data() {
            return {
                GOLD_TYPE_TOTAL : 1,
                GOLD_TYPE_MONTH : 2,
                GOLD_TYPE_WEEK : 3,
                listMap1 : null,
                listMap2 : null,
                listMap3 : null,    
                listMapNum : {},            
                rankIndex : 0,
                moneyIndex : 1,
                flag : 1,
                pageNum : 50
            }
        },
        components:{
            'rank-list' : RankList,
        },
        computed: {
            ...mapGetters('ranking', ['moneyRankingList', 'winRankingList']),
            totalNum(){
                return this.listMapNum[this.flag] ? this.listMapNum[this.flag] : 0
            }
        },
        methods: {
            ...mapActions('ranking', ['loadMoneyRanking', 'loadWinRanking']),
            achieveChange(flag){
                this.rankIndex = flag
                if(flag==1 && !this.winRank){
                     this.loadWin()
                }
            },
            achieveMoney(flag){
                this.flag = flag
                this.moneyIndex = flag
                if(!this['listMap' + flag]){
                    this.loadMoney()
                }
            },
            async loadMoney(){
                this.$toast.loading({
                    mask: true,
                    message: '加载中...'
                })
                const {flag, pageNum} = this
                const R = await this.loadMoneyRanking({
                    flag, pageNum
                })
                let list = R.list || []
                this['listMap' + flag] = list,
                this.listMapNum[flag] = R.num

                this.$toast.clear()
                console.log(this.listMapNum)
            },
            rankClass(index){
                return index < 3 ? ('sort-' + index) : ''
            },
        },
        created() {
            this.loadMoney()
            //this.loadWin()
        },
    }
</script>